<template>
  <v-row class="ma-0">
    <v-col cols="12" sm="4">
      <div class="groups-skills-tags">Age Group</div>
      <div class="mt-2">
        <span
          v-for="(group, index) in ageGroup"
          :key="index"
          style="font-weight: normal;font-size: 16px;line-height: 22px;color: rgba(51, 51, 51, 0.7);"
        >
          {{ index != ageGroup.length - 1 ? group.name + ", " : group.name }}
        </span>
      </div>
    </v-col>
    <v-col cols="12" sm="4">
      <div class="groups-skills-tags">Skills</div>
      <div class="mt-2">
        <span
          v-for="(skill, index) in skills"
          :key="index"
          style="font-weight: normal;font-size: 16px;line-height: 22px;color: rgba(51, 51, 51, 0.7);"
        >
          {{ index != skills.length - 1 ? skill.name + ", " : skill.name }}
        </span>
      </div>
    </v-col>
    <v-col cols="12" sm="4">
      <div class="groups-skills-tags">Tags</div>
      <div class="mt-2">
        <v-chip small class="me-2" v-for="(tag, i) in tags" :key="i">
          {{ tag.name }}
        </v-chip>
      </div>
    </v-col>
  </v-row>
</template>

<script>
  export default {
    name: "WorkshopGroupsSkillsTags",
    props: ["ageGroup", "skills", "tags"],
    components: {},
    data() {
      return {};
    },
    created() {},
    computed: {},
    watch: {},
    methods: {},
    mounted() {},
  };
</script>

<style scoped></style>
